module.exports = __webpack_public_path__ + "img/a11y-color-naming-1_en.f5a0321.jpg";